import { useMemo } from "react";

export const useWindowSize = () => {
  return useMemo(
    () => ({
      width: typeof window !== "undefined" ? window.innerWidth : Infinity,
      height: typeof window !== "undefined" ? window.innerHeight : Infinity,
    }),
    []
  );
};
